module.exports = __webpack_public_path__ + "static/media/rochelle_sheldon.5770d964.jpg";